var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedulingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.1641H3M16 2.16406V6.16406M8 2.16406V6.16406M7.8 22.1641H16.2C17.8802 22.1641 18.7202 22.1641 19.362 21.8371C19.9265 21.5495 20.3854 21.0905 20.673 20.526C21 19.8843 21 19.0442 21 17.3641V8.96406C21 7.28391 21 6.44383 20.673 5.80209C20.3854 5.2376 19.9265 4.77866 19.362 4.49104C18.7202 4.16406 17.8802 4.16406 16.2 4.16406H7.8C6.11984 4.16406 5.27976 4.16406 4.63803 4.49104C4.07354 4.77866 3.6146 5.2376 3.32698 5.80209C3 6.44383 3 7.2839 3 8.96406V17.3641C3 19.0442 3 19.8843 3.32698 20.526C3.6146 21.0905 4.07354 21.5495 4.63803 21.8371C5.27976 22.1641 6.11984 22.1641 7.8 22.1641Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingIcon);
export default __webpack_public_path__ + "static/media/SchedulingIcon.4969af651aeb492d41d2ec8b8016b0e2.svg";
export { ForwardRef as ReactComponent };